import React from "react";
import Input from "shared/@forms/Input";

export default function TextInput({ ...props }) {
  return <Input type="text" {...props} />;
}
